const itIsFreeOrTrialOrDeveloper = selectedSubscription =>
  selectedSubscription &&
  (selectedSubscription.name === 'Free' ||
    selectedSubscription.name === 'Developer' ||
    selectedSubscription.name === 'Trial');

export default itIsFreeOrTrialOrDeveloper;
